// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97f47eed","453":"e82872e4","455":"660bedc5"}[chunkId] + ".chunk.js";
};